//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import file from '@/utils/file';
Vue.use(file);
import Vue from 'vue';
export default {
  name: 'RightClick',
  props: {
    configData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      menuVisible: false,
      clickData: {
        index: -1,
        row: {}
      }
    };
  },
  methods: {
    rightItemClick: function rightItemClick(type) {
      this.clickData.index = type;
      this.clickData.row = this.configData.data;
      this.$emit('handleRightClick', this.clickData);
    },
    rightClick: function rightClick(event) {
      this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      event.preventDefault(); // 关闭浏览器右键默认事件
      var menu = document.querySelector('#contextmenu');
      var cha = document.body.clientHeight - event.clientY;
      // 防止菜单太靠底，根据可视高度调整菜单出现位置
      if (cha < 150) {
        menu.style.top = event.clientY - 120 + 'px';
      } else {
        menu.style.top = event.clientY - 10 + 'px';
      }
      menu.style.left = event.clientX + 10 + 'px';
      document.addEventListener('click', this.foo); // 给整个document添加监听鼠标事件，点击任何位置执行foo方法
    },
    foo: function foo() {
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener('click', this.foo); // 关掉监听，
    }
  }
};